import {
    Component,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { ApplicationService } from '../../../application/shared/services/application/application.service';
import { DashboardConstants } from '../../constants/dashboard-constants';
import { FormGroup, FormControl } from '@angular/forms';
import { FormGroupType } from '../../../../core/models/form-group-type';
import { DashboardFilterForm } from '../../models/dashboard-filter-form';
import { DashboardSegmentedToggleOption } from '../dashboard-segmented-toggle/models/dashboard-segmented-toggle-option';

@Component({
    selector: 'app-base-dashboard',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export abstract class BaseDashboardComponent implements OnInit, OnDestroy {
    readonly destroy$ = new Subject<void>();

    form: FormGroup<FormGroupType<DashboardFilterForm>> = new FormGroup<
        FormGroupType<DashboardFilterForm>
    >({
        status: new FormControl(
            DashboardConstants.ALL_APPLICATIONS_FILTER_VALUE,
        ),
    });

    constructor(protected readonly applicationService: ApplicationService) {}

    ngOnInit() {
        this.form.controls.status.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                tap(() => this.filterGridData()),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    protected abstract loadGridData(): void;

    protected abstract filterGridData(): void;

    protected abstract getSegmentedToggleOptions(): DashboardSegmentedToggleOption<string>[];
}
